export function debounce(func: (...args: unknown[]) => unknown, wait: number, immediate?: boolean) {
    let timeout: ReturnType<typeof setTimeout> | undefined;
    return function(this: unknown, ...args: unknown[]) {
        const context = this;
        const later = function() {
            timeout = undefined;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        const callNow = immediate && timeout === undefined;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}


